import request from '../http-request';

/**
 * 获取当前用户信息
 */
export const getMyInfo = () => {
  return request({
    method: 'GET',
    url: '/ovopark-organize/enterprise/getMyInfo',
    headers: {
      'Ovo-Authorization': window.ovopark.getToken(),
    },
  });
};
